import { render, staticRenderFns } from "./DocumentAttorney.vue?vue&type=template&id=8716ee6a&scoped=true&"
import script from "./DocumentAttorney.vue?vue&type=script&lang=js&"
export * from "./DocumentAttorney.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAttorney.vue?vue&type=style&index=0&id=8716ee6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8716ee6a",
  null
  
)

export default component.exports